import { render } from "./AccountWalletNav.vue?vue&type=template&id=1dc056ea&scoped=true"
import script from "./AccountWalletNav.vue?vue&type=script&lang=js"
export * from "./AccountWalletNav.vue?vue&type=script&lang=js"

import "./AccountWalletNav.vue?vue&type=style&index=0&id=1dc056ea&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1dc056ea"]])

export default __exports__